export const zollBaseURL = `${process.env.REACT_APP_ZOLL_API_URL}`

export const OKTA_LOGIN_URL = `${zollBaseURL}/api/OktaLogin/okta`
